import Router from 'next/router'

import logger from '@/utils/logger'

const SAME_URL_ERROR_MESSAGE = 'Invariant: attempted to hard navigate to the same URL'

export default async function refreshPage(): Promise<void> {
  try {
    await Router.replace(Router.asPath)
  } catch (err) {
    const shouldAttemptReload =
      err?.message != null && `${err.message}`.includes(SAME_URL_ERROR_MESSAGE)

    logger.error('Error refreshing route', { err, shouldAttemptReload })

    if (shouldAttemptReload) {
      Router.reload()
    }
  }
}
